// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"c5-z","colorTextValue":"d5-z","swatches":"e5-z","collapseLink":"f5-z","isCollapsed":"g5-z","dropdown":"h5-z","disabled":"i5-z"};